/*
 * mod='report'
 * author: v_fxinzhang
 * time: 2019-10-30
 */

import { smb_fetch, getAgpApiUrl } from '../../../fetch';
import { hasFeatureFlag } from '@/services';

const getReportApiUrl = (mod, act) => {
  const result = getAgpApiUrl(mod, act);

  return result;
};
/**
 * 获取管理员kpi列表
 * @return
 */
export const getPerformanceRptList = (data) => {
  const url = getReportApiUrl('report', 'get_performance_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取人效列表
 * @return
 */
export const getHumanEffectRptList = (data) => {
  const url = getReportApiUrl('report', 'get_human_effect_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取基础报表 -> 业务报表
 * @return
 */
export const getBaseRptList = (data) => {
  const url = getReportApiUrl('report', 'get_base_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};
/**
 * 获取广告主维度
 * @return
 */

export const getAdvertiserRptList = (data) => {
  const url = getReportApiUrl('report', hasFeatureFlag('is_change_get_to_post_enable') ? 'get_new_advertiser_rpt_list' : 'get_advertiser_rpt_list');
  const params = $.extend(
    true,
    {
      method: hasFeatureFlag('is_change_get_to_post_enable') ? 'POST' : 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取客户维度
 * @return
 */
export const getCustomerRptList = (data) => {
  const url = getReportApiUrl('report', 'get_customer_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 查询推广目标列表
 * @return
 */
export const getProductTypeList = (data) => {
  const url = getReportApiUrl('ad', 'get_product_type_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 查询广告位列表
 * @return
 */
export const getPositionList = (data) => {
  const url = getReportApiUrl('ad', 'get_position_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 查询版位列表
 * @return
 */
export const getPlacementGroupList = (data) => {
  const url = getReportApiUrl('ad', 'get_placement_group_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取营销单元维度
 * @return
 */
export const getAdRptList = (data) => {
  const url = getReportApiUrl('report', 'get_ad_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取账户维度 新
 * @return
 */
export const getAdvertiserRptListV2 = (data) => {
  const url = getReportApiUrl('report', 'get_advertiser_rpt_list_v2');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取基础报表 新
 * @return
 */
export const getAdBaseRptList = (data) => {
  const url = getReportApiUrl('report', 'get_ad_base_rpt_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
      ignoreTimeout: true,
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取指标列表
 * @return
 */
export const getIndicatorList = (data) => {
  const url = getReportApiUrl('report', 'get_indicator_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/**
 * 获取ADQ新指标列表
 * @return
 */
export const getMetricsList = (data) => {
  const url = getReportApiUrl('report', 'get_metrics_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params);
};

/*
 * 获取列表托管数据
 * @return
 */
export const getTrusteeshipList = (data, isShowError) => {
  const url = getReportApiUrl('collocation', 'get_list');
  const params = $.extend(
    true,
    {
      method: 'POST',
    },
    data,
  );
  return smb_fetch(url, params);
};

export default {
  getPerformanceRptList,
  getHumanEffectRptList,
  getBaseRptList,
  getAdvertiserRptList,
  getCustomerRptList,
  getProductTypeList,
  getPositionList,
  getPlacementGroupList,
  getAdRptList,
  getAdvertiserRptListV2,
  getAdBaseRptList,
  getIndicatorList,
  getTrusteeshipList,
};
